import React from 'react';
import Drawer from 'react-drag-drawer';
import './index.scss';

export default function DragDrawer({
  open,
  onRequestClose,
  position,
  children,
  containerOpacity = 0.67,
  allowClose = true,
}) {
  return (
    <Drawer
      open={open}
      onRequestClose={onRequestClose}
      containerElementClass={`drawer-container-${position}`}
      parentElement={document.getElementById('modal-container')}
      allowClose={allowClose}
      containerOpacity={containerOpacity}
    >
      {children}
    </Drawer>
  );
}
